module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0120.jpg?v=9aad169f";